import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel" className="flex min-h-[60vh] flex-col items-center justify-center px-5 text-center">
      <XCircle className="h-10 w-10 text-obsidian/40" />
      <h1 className="mt-6 font-serif text-3xl font-light tracking-tighter text-obsidian">Checkout cancelled</h1>
      <p className="mt-2 max-w-md text-sm text-obsidian/60">
        No charge was made. Your cart is still saved — pick up right where you left off.
      </p>
      <div className="mt-8 flex gap-3">
        <Link to="/cart" data-testid="back-to-cart-btn" className="border border-obsidian px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-obsidian transition-colors hover:bg-obsidian hover:text-white">
          Back to cart
        </Link>
        <Link to="/" className="bg-signal px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors hover:bg-red-700">
          Keep shopping
        </Link>
      </div>
    </div>
  );
}
